module.exports = __webpack_public_path__ + "media/images/ic_info-129a25e5a7accec5b2370e851051e0d7.svg";